<template>
  <div>
    <button
      class="btn btn-primary btn-sm"
      data-toggle="tooltip"
      data-placement="top"
      title="New"
      @click="fnShowModal()"
    >
      New
    </button>

    <b-modal ref="userModal" size="lg" hide-footer title="User - new">
      <div class="d-block">
        <form>
          <div class="row">
            <div class="col-lg-6 col-md-6 col-12">
              <div class="form-group">
                <b-form-select
                  plain
                  :options="roleOptions"
                  value-field="id"
                  text-field="text"
                  placeholder=" "
                  autocomplete="off_role"
                  v-model="role_id"
                ></b-form-select>
                <label class="floatingLabel" for="role">Role</label>
              </div>
              <div class="form-group">
                <b-form-select
                  plain
                  autocomplete="off_title"
                  placeholder=" "
                  :options="optionTitle"
                  v-model="title"
                ></b-form-select>
                <label class="floatingLabel" for="title">Title</label>
              </div>
              <div class="form-group">
                <b-form-select
                  plain
                  :options="getDesignationDropdown"
                  value-field="id"
                  text-field="name"
                  placeholder=" "
                  autocomplete="off_designationId"
                  v-model="designationId"
                ></b-form-select>
                <label class="floatingLabel" for="designationId"
                  >Designation</label
                >
              </div>
              <div class="form-group">
                <input
                  type="text"
                  class="form-control"
                  id="firstName"
                  placeholder=" "
                  autocomplete="off_firstName"
                  v-model="firstName"
                />
                <label class="floatingLabel" for="firstName">First name</label>
                <div class="invalid-feedback" v-if="errors.firstName">
                  {{ errors.firstName[0] }}
                </div>
              </div>
              <div class="form-group">
                <input
                  type="text"
                  class="form-control"
                  id="lastName"
                  placeholder=" "
                  autocomplete="off_lastName"
                  v-model="lastName"
                />
                <label class="floatingLabel" for="lastName">Last name</label>
                <div class="invalid-feedback" v-if="errors.lastName">
                  {{ errors.lastName[0] }}
                </div>
              </div>
              <div class="form-group">
                <input
                  type="text"
                  class="form-control"
                  id="position"
                  placeholder=" "
                  autocomplete="off_position"
                  v-model="position"
                />
                <label class="floatingLabel" for="position">Position</label>
              </div>

              <div class="form-group mt-3">
                <label for="imageUpload">Profile image upload</label>
                <div class="avatar-upload">
                  <div class="avatar-edit">
                    <input
                      ref="doc"
                      type="file"
                      id="imageUpload"
                      accept=".png, .jpg, .jpeg"
                      @change="onFileSelected($event)"
                    />
                    <label for="imageUpload"></label>
                  </div>
                  <div class="avatar-preview">
                    <div
                      v-if="profileImage"
                      id="imagePreview"
                      v-bind:style="{
                        backgroundImage: 'url(' + profileImage + ')'
                      }"
                    ></div>
                    <div v-else id="imagePreview">
                      <i class="las la-user-alt fs-12000 text-primary"></i>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-lg-6 col-md-6 col-12">
              <div class="form-group">
                <input
                  type="email"
                  class="form-control"
                  id="email"
                  placeholder=" "
                  autocomplete="off_email"
                  v-model="email"
                />
                <label class="floatingLabel" for="email">Email</label>
                <div class="invalid-feedback" v-if="errors.email">
                  {{ errors.email[0] }}
                </div>
              </div>
              <div class="form-group">
                <input
                  type="text"
                  class="form-control"
                  id="officePhone"
                  placeholder=" "
                  autocomplete="off_officePhone"
                  v-model="officePhone"
                />
                <label class="floatingLabel" for="officePhone"
                  >Office phone</label
                >
              </div>
              <div class="form-group">
                <input
                  type="text"
                  class="form-control"
                  id="mobilePhone"
                  placeholder=" "
                  autocomplete="off_mobilePhone"
                  v-model="mobilePhone"
                />
                <label class="floatingLabel" for="mobilePhone"
                  >Mobile phone</label
                >
              </div>
              <div
                class="form-group"
                v-if="role_id == 1 || role_id == 2 || role_id == 3"
              >
                <input
                  type="text"
                  class="form-control"
                  id="calendlyLink"
                  placeholder=" "
                  autocomplete="off_calendlyLink"
                  v-model="calendlyLink"
                />
                <label class="floatingLabel" for="calendlyLink"
                  >Calendly Link</label
                >
              </div>
              <div class="form-group" v-if="isDealerShow()">
                <label class="typo__label">Dealer/s</label>
                <multiselect
                  v-model="dealers"
                  tag-placeholder="Add this as new tag"
                  placeholder="Search or add a dealer"
                  label="name"
                  track-by="id"
                  :options="getDealerDropdown"
                  :multiple="true"
                  :taggable="true"
                >
                </multiselect>
              </div>

              <div class="form-group" v-if="isDealerShow()">
                <label class="typo__label">BDM team member/s</label>
                <multiselect
                  v-model="bdm_users"
                  placeholder="Search or add a BDM team member/s"
                  label="name"
                  track-by="id"
                  :options="getDealerStaffDropdown"
                  :multiple="true"
                  :taggable="true"
                >
                </multiselect>
              </div>

              <div class="form-group" v-if="isReferralPartnerShow()">
                <label class="typo__label">Referral partner/s</label>
                <multiselect
                  v-model="referralPartners"
                  tag-placeholder="Add this as new tag"
                  placeholder="Search or add a partner"
                  label="name"
                  track-by="id"
                  :options="getReferralPartnerDropdownList"
                  :multiple="true"
                  :taggable="true"
                >
                </multiselect>
              </div>

              <div class="form-group" v-if="isMaxBrokerageShow()">
                <b-form-select
                  plain
                  :options="maxBrokerageOptions"
                  value-field="text"
                  text-field="text"
                  placeholder=" "
                  autocomplete="off_maxBrokerage"
                  v-model="maxBrokerage"
                ></b-form-select>
                <label class="floatingLabel" for="maxBrokerage"
                  >Max Brokerage (%)</label
                >
              </div>
            </div>
            <div class="col-lg-12 col-md-12 col-12 mt-3">
              <b-form-group
                label="Profile Settings"
                v-slot="{ ariaDescribedby }"
                class=""
              >
                <b-form-checkbox
                  v-for="option in userSettingOptions"
                  v-model="userSettings"
                  :key="option.name"
                  :value="option.name"
                  :aria-describedby="ariaDescribedby"
                  name="flavour-4a"
                  inline
                >
                  {{ option.title }}
                </b-form-checkbox>
              </b-form-group>
            </div>
          </div>
          <hr />
          <div class="text-right">
            <button
              type="button"
              class="btn btn-dark btn-sm mr-2"
              @click="hideModal"
            >
              Cancel
            </button>
            <button
              type="button"
              @click="createNew"
              class="btn btn-primary btn-sm"
            >
              <b-spinner small v-if="is_spinActive"></b-spinner>
              Save
            </button>
          </div>
        </form>
      </div>
    </b-modal>
  </div>
</template>
<script>
import { mapGetters, mapActions } from 'vuex'
import Multiselect from 'vue-multiselect'
import * as messageService from '../../../services/message.service'
import * as userService from '../../../services/user.service'
import { serialize } from 'object-to-formdata'
import {
  maxBrokerageOptions,
  roleOptions,
  optionTitle,
  getSideBarItems
} from '../../../services/data.service'
export default {
  name: 'ModelUserNew',
  components: {
    Multiselect
  },
  data() {
    return {
      errors: {},
      id: '',
      title: 'Mr',
      designationId: '',
      firstName: '',
      middleName: '',
      lastName: '',
      email: '',
      role_id: 4,
      dealers: [],
      bdm_users: [],
      referralPartners: [],
      position: '',
      maxBrokerage: 6,
      officePhone: '',
      mobilePhone: '',
      profileImage: '',
      is_spinActive: false,
      userSettingOptions: [],
      userSettings: [],
      calendlyLink: '',
      maxBrokerageOptions: maxBrokerageOptions,
      roleOptions: roleOptions,
      optionTitle: optionTitle,
      selectedFile: ''
    }
  },
  computed: {
    ...mapGetters([
      'getDealerDropdown',
      'getAdminUserPaginate',
      'getReferralPartnerDropdownList',
      'getDealerStaffDropdown',
      'getDesignationDropdown'
    ])
  },
  methods: {
    ...mapActions([
      'fetchAdminUserPaginateData',
      'fetchDealerDropdown',
      'fetchReferralPartnerDropdownList',
      'fetchDealerStaffDropdown',
      'fetchDesignationDropdown'
    ]),
    /**
     * Show only Brokerage
     */
    isMaxBrokerageShow() {
      if (this.role_id != 5 && this.role_id != 3) {
        return true
      }
      return false
    },
    /**
     * Show Referral Partner
     */
    isReferralPartnerShow() {
      if (this.role_id != 3) {
        return true
      }

      return false
    },
    /**
     * Show Dealers
     */
    isDealerShow() {
      if (this.role_id != 5) {
        return true
      }
      return false
    },
    fnShowModal() {
      this.showModal()
    },
    hideModal() {
      this.$refs.userModal.hide()
    },
    showModal() {
      /**
       * Load Designations
       */
      this.fetchDesignationDropdown()
      /**
       * Load VSA BDMs
       */
      this.fetchDealerStaffDropdown(73)
      /**
       * Load All the Dealers
       */
      this.fetchDealerDropdown()
      /**
       * Load All Referral partners
       */
      this.fetchReferralPartnerDropdownList('a')
      this.$refs.userModal.show()
    },

    createNew: async function () {
      this.is_spinActive = true
      const ramPass = Math.random().toString(36).substring(2, 10)

      let user_data = {
        role_id: this.role_id,
        title: this.title,
        designationId: this.designationId,
        firstName: this.firstName,
        middleName: this.middleName,
        lastName: this.lastName,
        email: this.email,
        maxBrokerage: this.maxBrokerage,
        dealers: this.dealers,
        bdm_users: this.bdm_users,
        referralPartners: this.referralPartners,
        position: this.position,
        officePhone: this.officePhone,
        mobilePhone: this.mobilePhone,
        profileImage: this.profileImage,
        password: ramPass,
        password_confirm: ramPass,
        image: this.selectedFile,
        settings: this.userSettings,
        calendlyLink: this.calendlyLink
      }

      const options = {
        /**
         * include array indices in FormData keys
         * defaults to false
         */
        indices: true,

        /**
         * treat null values like undefined values and ignore them
         * defaults to false
         */
        nullsAsUndefineds: false,

        /**
         * convert true or false to 1 or 0 respectively
         * defaults to false
         */
        booleansAsIntegers: false,

        /**
         * store arrays even if they're empty
         * defaults to false
         */
        allowEmptyArrays: true,

        /**
         * don't include array notation in FormData keys for Files in arrays
         * defaults to false
         */
        noFilesWithArrayNotation: true,

        /**
         * use dots instead of brackets for object notation in FormData keys
         * defaults to false
         */
        dotsForObjectNotation: false
      }

      const formData = serialize(
        user_data,
        options // optional
        // existingFormData, // optional
        // keyPrefix // optional
      )

      try {
        const response = await userService.add(formData)
        this.fetchAdminUserPaginateData(this.getAdminUserPaginate)
        this.hideModal()
        messageService.fnSweetAlertSuccessToast('User', 'Added successfully')
        this.is_spinActive = false

        this.id = ''
        this.title = 'Mr'
        this.designationId = ''
        this.firstName = ''
        this.middleName = ''
        this.lastName = ''
        this.email = ''
        this.role_id = 2
        this.dealers = []
        this.bdm_users = []
        this.referralPartners = []
        this.position = ''
        this.maxBrokerage = 6
        this.officePhone = ''
        this.mobilePhone = ''
        this.profileImage = ''
        this.userSettings = []
        this.calendlyLink = ''
      } catch (error) {
        switch (error.response.status) {
          case 422:
            this.errors = error.response.data.errors
            break

          case 500:
            messageService.fnSweetAlertErrorToast(
              'User - new',
              error.response.data.message
            )
            break

          default:
            messageService.fnSweetAlertErrorToast(
              'User - new',
              'Something wrong'
            )
            break
        }
        this.is_spinActive = false
      }
    },
    onFileSelected(event) {
      const selectedFile = event.target.files
      this.selectedFile = event.target.files[0]
      if (!selectedFile.length) return

      const reader = new FileReader()
      reader.readAsDataURL(selectedFile[0])
      reader.onload = () => (this.profileImage = reader.result)
    }
  },
  watch: {
    role_id(val) {
      this.userSettingOptions = getSideBarItems(val)
    }
  }
}
</script>
